<div class="bg-white active:bg-gray-50 shadow-sm rounded-lg p-4 mb-4 gap-4">
  <div class="flex items-start">
    <h2 *ngIf="title" class="text-xl flex-1 font-semibold mb-4">{{title}}</h2>
    <div *ngIf="statusColor" class="flex-shrink-0">
      <span [ngClass]="statusColor" class="block h-4 w-4 rounded-full"></span>
    </div>
  </div>
  <ng-content></ng-content>
</div>
